import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Images
import vendor1 from "./logo/logo/1.webp";
import vendor2 from "./logo/logo/2.webp";
import vendor3 from "./logo/logo/3.webp";
import vendor4 from "./logo/logo/4.webp";
import vendor5 from "./logo/logo/5.webp";
import vendor6 from "./logo/logo/6.webp";
import vendor7 from "./logo/logo/7.webp";
import vendor8 from "./logo/logo/8.webp";
import vendor9 from "./logo/logo/9.webp";
import vendor10 from "./logo/logo/10.webp";
import vendor11 from "./logo/logo/11.webp";
import vendor12 from "./logo/logo/12.webp";
import vendor13 from "./logo/logo/13.webp";
import vendor14 from "./logo/logo/14.webp";
import vendor15 from "./logo/logo/15.webp";
import vendor16 from "./logo/logo/16.webp";
import vendor17 from "./logo/logo/17.webp";
import vendor18 from "./logo/logo/18.webp";
import vendor19 from "./logo/logo/19.webp";
import vendor20 from "./logo/logo/20.webp";
import vendor21 from "./logo/logo/21.webp";
import vendor22 from "./logo/logo/22.webp";
import vendor23 from "./logo/logo/23.webp";
import vendor24 from "./logo/logo/24.webp";
import vendor25 from "./logo/logo/25.webp";
import vendor26 from "./logo/logo/26.webp";
import vendor27 from "./logo/logo/27.webp";
import vendor28 from "./logo/logo/28.webp";
import vendor29 from "./logo/logo/29.webp";
import vendor30 from "./logo/logo/30.webp";
import vendor31 from "./logo/logo/31.webp";
import vendor32 from "./logo/logo/32.webp";
import vendor33 from "./logo/logo/33.webp";
import vendor34 from "./logo/logo/34.webp";
import vendor35 from "./logo/logo/35.webp";
import vendor36 from "./logo/logo/36.webp";
import vendor37 from "./logo/logo/37.webp";


const vendors = [
  vendor1, vendor2, vendor3, vendor4, vendor5, vendor6, vendor7, vendor8, vendor9,
  vendor10, vendor11, vendor12, vendor13, vendor14, vendor15, vendor16, vendor17, vendor18,
  vendor19, vendor20, vendor21, vendor22, vendor23,vendor24, vendor25, vendor26, vendor27, vendor28, vendor29, vendor30, vendor31, vendor32, vendor33, vendor34, vendor35, vendor36, vendor37,
];

const VendorCarousel = () => {
  const settings = {
  dots: false,
  infinite: true,
  speed: 3000,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  arrows: false,
  pauseOnHover: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 5 } },
    { breakpoint: 992, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 576, settings: { slidesToShow: 2 } }
  ]
};



  return (
    <>
    <div className="projects-header1 py-5">
          <h2 className="section-titles" data-aos="fade-up"><span className="section-titles-2">NOS</span> partenaires</h2>
          <p data-aos="fade-up">Des partenaires de confiance pour des projets d’excellence</p>
    </div>
    <div className="container-fluid section6" data-aos="zoom-in"
     data-aos-duration="3000">
      <div className="container mb-5">
        <div className="bg-white vendor-wrap">
          <Slider {...settings}>
            {vendors.map((src, i) => (
              <div key={i}>
                <img src={src} alt={`vendor-${i}`} loading="lazy" className="vendor-img" />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
    </>
  );
};

export default VendorCarousel;
